import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { DOCUMENT_MODULE_NAMESPACE } from '../../../../../store/document';
import { IDocumentTypeListingViewmodel, DocumentModel, IDocumentModel } from '../../../../../models/documents';

const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)

@Component
class BlockModal extends Vue {

  _clearTimeout: any;
  dtButtonStyle: any | null;
  dtButtonHeight: number | null;
  @DocumentStore.Getter documentTypes: IDocumentTypeListingViewmodel[];

  @Prop({ default: () => [], type: [Array] })
  value: IDocumentModel[]
  /**
   *
   */
  constructor() {
    super();
    this.dtButtonHeight = 76.5;
    this.dtButtonStyle = null;
  }
  get coDocymentTypes(): IDocumentTypeListingViewmodel[] {
    return this.documentTypes;
  }
  get vModel(): IDocumentModel[] {
    return this.value;
  }
  set vModel(vals: IDocumentModel[]) {
    console.log(vals)
    this.$emit('input', vals);
  }

  getButtonStyle(refName: string) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(async () => {
      if (this.$refs[refName][0]) {
        const ele = this.$refs[refName][0].$el;
        this.dtButtonHeight = (ele.clientWidth - (ele.clientWidth * 8) / 100);
      }
    }, 10);
    return {
      height: `calc(${this.dtButtonHeight}px)`
    };
  }
  handleUploadDocument(index: number, item: IDocumentTypeListingViewmodel) {

    //@ts-ignore
    const btn = this.$refs[`input-${item.type}-${item.id}`][0];
    btn.click();
  }
  handleAddFile(target: any, item: any, index: number) {

    this.vModel = [...this.vModel, ...Array.from(target.files).map((file: File, index: number) => ({
      fakeId: `${file.lastModified}-${this.vModel.length}`,
      type: 'document',
      name: file.name,
      createdAt: new Date(),
      fk_attachment_type: item.id,
      file: this.parseFileToBase64(file, target)
    }))]

  }
  parseFileToBase64(file: File, target: any) {
    const base64: any = new FileReader()
    base64.readAsDataURL(file);
    target.value = null; //Reset value for input
    return base64;
  }
  handleRemoveFile(file) {
    this.vModel = this.vModel.filter(x => x.fakeId !== file.fakeId)
  }
  mounted() {
    this.handleCalculateShapeOfButton();
    window.onresize = () => this.handleCalculateShapeOfButton()
  }
  handleCalculateShapeOfButton() {
    let intervalMapTracer: any;
    let isCleared: boolean;
    this.$nextTick(() => {
      isCleared = false;
      if (!isCleared) {
        intervalMapTracer = setInterval(() => {
          clearInterval(intervalMapTracer);
          const form = this.$refs.documentModalRef as any;
          if (form) {
            isCleared = true;
            this.dtButtonStyle = {
              height: (form.clientWidth / 4 - 10) + 'px',
              width: (form.clientWidth / 4 - 10) + 'px',
            }
          }

        }, 300)
      }

    })

  }
}

export default BlockModal;


// WEBPACK FOOTER //
// ./src/containers/block/block-documents/components/block-document-modal/index.ts